import * as React from "react";
import Modal from "../../misc/components/modal";
import { CoughAnalysisSetType } from "../../misc/api/apiTypes";
import Loading from "../../misc/components/loading";
import AsyncActionButton from "../../misc/components/AsyncActionButton";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

interface CreateLinkedModalProps {
    selectedAnalysisSet: string;
    onClose: () => void;
}

const CreateLinkedModal = ({ selectedAnalysisSet, onClose }: CreateLinkedModalProps): JSX.Element => {
    const [coughAnalysisSetTypes, setCoughAnalysisSetTypes] = React.useState<Array<CoughAnalysisSetType>>(null);
    const [selectedQAType, setSelectedQAType] = React.useState<string>(null);
    const [isFetching, setIsFetching] = React.useState<boolean>(true);
    const [error, setError] = React.useState<string>(null);
    const legacyClient = useWebPortalLegacyClient();

    const resetModal = () => {
        setIsFetching(false);
        setError(null);
    }

    const resetModalAndClose = () => {
        resetModal();
        onClose();
    }

    React.useEffect(() => {
        setIsFetching(true);
        setError(null);
        legacyClient.fetchQAAnalysisSetTypes().then(anSetTypes => {
            setCoughAnalysisSetTypes(anSetTypes);
            setSelectedQAType(anSetTypes[0].Id);
            setIsFetching(false);
        }).catch(err => {
            setIsFetching(false);
            setError(err.Message);
        });

    }, []);

    const onCreate = () => {
        setIsFetching(true);
        setError(null);
        legacyClient.createNewLinkedAnalysisSet(selectedAnalysisSet, selectedQAType)
            .then(() => {
                resetModalAndClose();
            })
            .catch(err => {
                setIsFetching(false);
                setError(err.Message);
            });
    };

    return (
        <Modal
            show={true}
            closeModalHandler={onClose}
            header="Create A Linked QA Analysis Set"
        >
            <div className="modal-body">
                <Alert show={!!error} category={AlertCategoryEnum.Danger}>
                    {error}
                </Alert>
                {coughAnalysisSetTypes ? <select
                    className="form-control"
                    value={selectedQAType}
                    onChange={e => setSelectedQAType(e.target.value)}
                >
                    {coughAnalysisSetTypes.map(i => (
                        <option key={i.Id} value={i.Id}>
                            {i.Name}
                        </option>
                    ))}
                </select> : <Loading />}
            </div>
            <div className="modal-footer">
                <AsyncActionButton
                    isSubmitting={isFetching}
                    className="btn btn-primary"
                    onClick={onCreate}
                >
                    Create Linked QA Analysis Set
                    </AsyncActionButton>
                <button
                    className="btn btn-outline btn-primary"
                    onClick={resetModalAndClose}
                >
                    Close
                </button>
            </div>
        </Modal>
        );
};

export default CreateLinkedModal;
